import { getOptionValue, validateOptions } from "@helpers/options";
import React from "react";
import { Menu } from "semantic-ui-react";

class BaseSettings extends React.Component {
  state = {
    selectedOperator: null,
    activeMenu: { id: null, type: "options" },
    saveCallback: () => {}, // Gets called after saving.
    changed: [],
    statuses: {
      online: true,
      offlineSiteOpen: true,
      pending: true,
      authReq: true,
      offlineSiteClosed: true,
      onlineEFTDisabled: true,
      onlineNoFunds: true,
    },
    quantities: {
      onlineQty: 0,
      onlineEFTEnabledQty: 0,
      offlineSiteOpenQty: 0,
      pendingQty: 0,
      authReqQty: 0,
      offlineSiteClosedQty: 0,
      unknownQty: 0,
      onlineEFTDisabledQty: 0,
      onlineNoFundsQty: 0,
    },
  };

  mapChanged = (options, stateKey = "changed") => {
    return options
      ? options.map((option) => {
          const changed = this.state[stateKey].find(
            (change) => change.code === option.code,
          );
          return changed ? changed : option;
        })
      : [];
  };

  getChanged = (stateKey = "changed") => {
    let changed = {};

    this.state[stateKey].forEach((x) => {
      if (x.code) changed[x.code] = x.value;
    });

    return changed;
  };

  getAll = (options, stateKey = "changed") => {
    const changed = {};
    const fields = Array.isArray(options)
      ? options
      : [...options.main, ...options.operational, ...options.ownership];
    const mapped = this.mapChanged(fields, stateKey);

    mapped.forEach((x) => {
      if (x.code && getOptionValue(x)) changed[x.code] = getOptionValue(x);
    });

    return changed;
  };

  isAllValid = (options, stateKey = "changed") => {
    if (options.length < 1) return false;

    const fields = Array.isArray(options)
      ? options
      : [...options.main, ...options.operational, ...options.ownership];
    const all = this.mapChanged(fields, stateKey);

    return validateOptions(all);
  };

  isValid = (stateKey = "changed") => validateOptions(this.state[stateKey]);

  handleReload = () => {}; // adding as default

  handleMenuChange = (item) => {
    this.setState({ activeMenu: item });
  };

  handleChangeValue = async (
    option,
    value,
    stateKey = "changed",
    reallyDoRefresh = true,
  ) => {
    const changed = [...this.state[stateKey]].filter(
      (x) => x.code !== option.code,
    );
    changed.push({ ...option, value });
    this.setState({ [stateKey]: changed }, () => {
      if (!option.doRefresh) {
        return;
      }

      if (!reallyDoRefresh) {
        // sometimes we need to override the doRefresh behaviour
        return;
      }

      this.handleReload();
    });
  };

  getMenuItems = (subTypes) => {
    return subTypes.map((item) => {
      return (
        <Menu.Item
          key={item.name}
          name={item.name}
          active={this.state.activeMenu.id === item.id}
          onClick={() => this.handleMenuChange(item)}
        />
      );
    });
  };
}

export default BaseSettings;
